import { gql } from '@eti/schema-types';

export const SELECT_LANGUAGE_MUTATION = gql(/* GraphQL */ `
  mutation languageSelection($id: Long!) {
    selectLanguage(id: $id) {
      success
    }
  }
`);
